import stringCaseUtils from "util/stringCaseUtils";
import forEach from "lodash/forEach";
import functionsIn from "lodash/functionsIn";
import isUndefined from "lodash/isUndefined";
import { action } from "mobx";
import clientErrorLogger from "util/clientErrorLogger";
import toUpper from "lodash/toUpper";

const constantName = (str) => {
    return toUpper(stringCaseUtils.camelCaseToSnakeCase(str));
};

// "dispatchable" is a total lie. we are simply making the function enumerable so that events() can pick it up through functionsIn
export function dispatchable(target, functionName, descriptor) {
    descriptor.enumerable = true;
    return descriptor;
}

export class ActionStore {
    constructor(dispatcher) {
        this.dispatcher = dispatcher;
        this._registeredModals = {};
        this.logger = clientErrorLogger;

        // cheap debugging trick
        if (typeof (window) !== "undefined") {
            window["__" + this.constructor.name] = this;
        }
    }

    // register all functions that we can enumerate
    events() {
        let eventRegistry = {};
        forEach(functionsIn(this), (functionName) => {
            eventRegistry[constantName(functionName)] = action(this[functionName]);
        });
        return eventRegistry;
    }

    onBind(dispatcher) {
        this.dispatcher = dispatcher;
    }

    registerModals(modalArray) {
        forEach(modalArray, m => {
            this._registeredModals[m.modalKey] = m;
        });
    }

    @dispatchable
    openModal(e) {
        if (!isUndefined(this._registeredModals[e.data.modalKey])) {
            // pass dispatcher for async endpoint modals
            this._registeredModals[e.data.modalKey].open(e.data.dispatcher);
        }
    }

    @dispatchable
    hideModal(e) {
        if (!isUndefined(this._registeredModals[e.data.modalKey])) {
            this._registeredModals[e.data.modalKey].close();
        }
    }
}
